"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Txt = exports.align = exports.truncate = exports.bold = exports.italic = exports.caps = exports.whitespace = void 0;
var React = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var styled_system_1 = require("styled-system");
var asRendition_1 = __importDefault(require("../../asRendition"));
var utils_1 = require("../../utils");
exports.whitespace = function (props) {
    return props.whitespace
        ? styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t\t\t\twhite-space: ", ";\n\t\t  "], ["\n\t\t\t\twhite-space: ", ";\n\t\t  "])), props.whitespace) : null;
};
exports.caps = function (props) {
    return props.caps
        ? styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\t\t\t\ttext-transform: uppercase;\n\t\t\t\tletter-spacing: 0.2em;\n\t\t  "], ["\n\t\t\t\ttext-transform: uppercase;\n\t\t\t\tletter-spacing: 0.2em;\n\t\t  "]))) : null;
};
exports.italic = function (props) {
    return props.italic
        ? styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\t\t\t\tfont-style: italic;\n\t\t  "], ["\n\t\t\t\tfont-style: italic;\n\t\t  "]))) : null;
};
exports.bold = function (props) {
    return props.bold
        ? styled_components_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\t\t\t\tfont-weight: ", ";\n\t\t  "], ["\n\t\t\t\tfont-weight: ", ";\n\t\t  "])), props.theme.weights[props.theme.weights.length - 1]) : null;
};
exports.truncate = function (props) {
    return props.truncate && styled_components_1.css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\t\toverflow: hidden;\n\t\ttext-overflow: ellipsis;\n\t\twhite-space: nowrap;\n\t"], ["\n\t\toverflow: hidden;\n\t\ttext-overflow: ellipsis;\n\t\twhite-space: nowrap;\n\t"])));
};
exports.align = styled_system_1.style({
    key: 'text-align',
    prop: 'align',
    cssProperty: 'text-align',
});
var BaseTxt = styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\t", "\n\t", "\n\t", "\n\n\t", "\n\t", "\n\t", "\n\n\t", "\n"], ["\n\t", "\n\t", "\n\t", "\n\n\t", "\n\t", "\n\t", "\n\n\t", "\n"])), exports.align, utils_1.monospace, exports.whitespace, exports.caps, exports.bold, exports.italic, exports.truncate);
var Factory = function (tag) {
    return asRendition_1.default(function (props) {
        return React.createElement(BaseTxt, __assign({ as: tag }, props));
    });
};
var Base = Factory();
Base.displayName = 'Txt';
Base.span = Factory('span');
Base.p = Factory('p');
exports.Txt = Base;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
